import { ADD_SALE_NOTIFICATION, REMOVE_SALE_NOTIFICATION } from '../constants/sale-notifications';

const initialState = {
  notifications: [],
};

function saleNotifications(state = initialState, action) {
  switch (action.type) {
    case ADD_SALE_NOTIFICATION:
      return { ...state, notifications: [...state.notifications, action.payload] };
    case REMOVE_SALE_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.filter(notification => notification.id !== action.payload),
      };
    default:
      return state;
  }
}

export default saleNotifications;
